package com.steamstreet.vegasful.browser.public

import com.steamstreet.vegasful.web.analytics.Analytics
import com.steamstreet.vegasful.web.analytics.AnalyticsEvent
import com.steamstreet.vegasful.web.analytics.AnalyticsParam
import com.steamstreet.vegasful.web.analytics.pageTypeOf
import kotlinx.browser.window
import org.w3c.dom.Element
import org.w3c.dom.asList

fun eventScroller(element: Element) {
    val content = element.querySelector(".event-scroller-content")
    val contentElement = content?.firstElementChild
    element.querySelectorAll(".scroll-navigation-button").asList().forEach {
        (it as? Element)?.let {
            val direction = it.getAttribute("data-direction")
            it.addEventListener("click", {
                // The scrollers are most of what a listing page is, and until now nothing said
                // whether anybody moves past the first few cards. Only the buttons are reported:
                // a scroll event fires continuously and would swamp everything else.
                Analytics.track(
                    AnalyticsEvent.SCROLLER_ADVANCED,
                    AnalyticsParam.DIRECTION to direction,
                    AnalyticsParam.PAGE_TYPE to pageTypeOf(window.location.pathname)
                )

                var widthToScroll = (contentElement?.clientWidth ?: 0) + 10
                if (direction == "left") {
                    widthToScroll = -widthToScroll
                }
                content?.parentElement?.scrollBy(widthToScroll.toDouble(), 0.0)
            })
        }
    }
}
